export const BULK_DOWNLOAD_PROGRESS_PHASE = {
	DOWNLOADING: 'downloading',
	PREPARING: 'preparing',
	ZIPPING: 'zipping',
} as const

/** Ignore tiny early samples that produce unstable ETAs. */
export const MIN_FILE_DOWNLOAD_FRACTION_FOR_ESTIMATE = 0.01

/** Let the zip→download transition settle before showing an ETA. */
export const REMAINING_DOWNLOAD_TIME_WARMUP_MS = 1_000

/** Soften optimistic ETAs so the label does not under-promise. */
export const REMAINING_DOWNLOAD_TIME_PADDING = 1.05

/** How often the remaining-time label refreshes. */
export const REMAINING_DOWNLOAD_TIME_UPDATE_MS = 1_000
